import React from 'react';

import { config } from 'config/env-config';
import { selectIsAuthed } from 'store/customer';
import { useAppSelector } from 'store/store';

import { AP_FOOTER_TEST_ID } from './Footer.test-ids';

const Footer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ ...props }) => {
  const isAuthed = useAppSelector(selectIsAuthed);
  return (
    <>
      {React.createElement('ap-footer-wc', {
        envurl: config.env.url,
        authenticated: isAuthed,
        'data-testid': AP_FOOTER_TEST_ID,
        ...props,
      })}
    </>
  );
};

export default Footer;
